import { Address } from "./address";

export class Users {

    createdTime: Date;

    deleted: boolean;
    email: string;
    enabled: boolean;
    lastLoginTime: Date;
    locked: boolean;
    mobile: string;
    password: string;

    title: string;
    id: number;
    about: string;

    name: string;
    firstName: string;
    lastName: string;
    avatar: string;
    status: string;

    role: string;
    address: Address

}
